import { Component, HostBinding, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { iValidatedControl } from '../iValidatedControl';
import { BaseCustomControl } from '../baseCustomControl';

@Component({
  selector: 'app-check-input',
  templateUrl: './check-input.component.html',
  providers: [
    // see https://blog.thoughtram.io/angular/2016/07/27/custom-form-controls-in-angular-2.html
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckInputComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CheckInputComponent
  extends BaseCustomControl
  implements ControlValueAccessor, iValidatedControl
{
  @HostBinding('class.formField') formFieldClass = true; // Always applied
  @HostBinding('class.readOnly') get isReadOnly() {
    return this.readonly;
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if ((!this.validationMsg || this.validationMsg == '') && this.required) {
      this.validationMsg = 'required';
    }
  }

  // This writes the boundValue back to the Angular model
  handle_change(e: any): void {
    this.onChange(this.boundValue);

    if (this.onChanged) {
      this.onChanged.emit(this.boundValue);
    }
  }

  public validate(): boolean {
    return true;
  }
}
